import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ProfileCard from '../ProfileCard/ProfileCard';
import { ContactPhoneOutlined, EmailOutlined, KeyboardArrowDownOutlined, LocalPhoneOutlined, ModeOutlined, ModeStandbyOutlined, OfflineBoltOutlined, PrivacyTipOutlined, RoomPreferencesOutlined, SettingsAccessibilityOutlined, SettingsApplications, SettingsApplicationsOutlined, SettingsOutlined } from '@mui/icons-material';
import MainButton from '../../../../Components/common/buttons/MainButton';
import colors from '../../../../scss/colors';
import { Badge, Box, CircularProgress, Tooltip } from '@mui/material';
import NudgeIcon from '../../../../Components/common/CustomIcon/CustomIcon';

function ProfileHeader({
  isJobPreferenceComplete,
  userName = '',
  jobTitle = '',
  location = '',
  email = '',
  phone = '',
  contactType = '',
  isJobSeeking,
  onOpenToWork = () => {},
  onCasuallySeeking = () => {},
  handleEditPersonalDetails = () => {},
  handleJobPreferences = () => {},
  handleConsent = () => {},
  isJobSeekingPending
}) {
  const { t } = useTranslation();

  const shouldShowNudge = !location || !email || !phone || !contactType;


  return (
    <ProfileCard customClass="md:gap-6">
      <div className='flex flex-col sm:flex-row justify-between items-start w-full gap-1 sm:gap-2'>
        <div className='flex flex-col gap-1 sm:gap-2'>
          <h2 className='!text-2xl sm:!text-3xl m-0 !font-medium text-navy-blue'>{userName}</h2>
          <p className='text-black text-sm sm:text-base'>{jobTitle || t('dashboard.profile.jobTitlePlaceholder')}</p>
          <p className='text-gray-500 text-sm sm:text-base'>{location || t('dashboard.profile.locationPlaceholder')}</p>
        </div>
        <div className='flex flex-col gap-1 sm:gap-2'>
          <p className='text-gray-500 flex gap-2'>
            <span><EmailOutlined fontSize='15' /></span>
            <span className='items-start text-sm sm:text-base'>{email}</span>
          </p>
          <p className='text-gray-500 flex gap-2'>
            <span><LocalPhoneOutlined fontSize='15' /></span>
            <span className='items-start text-sm sm:text-base'>{phone.trim() ? phone : t('dashboard.profile.phonePlaceholder')}</span>
          </p>
          <p className='text-gray-500 flex gap-2'>
            <span><ContactPhoneOutlined fontSize='15' /></span>
            <span className='items-start text-sm sm:text-base'>{contactType || t('dashboard.profile.contactTypePlaceholder')}</span>
          </p>
        </div>
      </div>
      <div className='flex gap-4 sm:items-center flex-col-reverse sm:flex-row justify-between items-start w-full'>
        <div className='flex gap-3 w-fit'>
          <MainButton
            size='xsmall'
            variant='secondary'
            rounded
            action={onOpenToWork}
            forceWidth={'100%'}
            customClass='py-2 h-[40px] md:h-auto text-xs md:!text-sm !font-medium'
          >
            <span>{t('dashboard.profile.opento')}</span>
            <span><KeyboardArrowDownOutlined /></span>
          </MainButton>
          <MainButton
            size='xsmall'
            outlined={isJobSeeking ? false : true}
            variant={'primary'}
            rounded
            action={onCasuallySeeking}
            forceWidth={'100%'}
            customClass='py-2 h-[40px] md:h-auto text-xs md:!text-sm !font-medium'
          >
            {isJobSeekingPending ? (
              <CircularProgress
                size={24}
                sx={{
                  color: isJobSeeking ? colors.WHITE : colors.NAVY_BLUE
                }}
              />
            ) : (
              <>
                <span className='pr-1'>{isJobSeeking ? <OfflineBoltOutlined /> : <ModeStandbyOutlined />}</span>
                <span>{isJobSeeking ? t('dashboard.profile.activelyseeking') : t('dashboard.profile.casuallyseeking')}</span>
              </>
            )}

          </MainButton>
        </div>
        <div className='flex gap-3 items-center justify-end sm:justify-between w-full sm:w-fit'>
          <PrivacyTipOutlined 
            sx={{
              color: colors.NAVY_BLUE,
              cursor: 'pointer',
            }}
            onClick={handleConsent} 
          />
          <NudgeIcon
            iconComponent={<RoomPreferencesOutlined />}
            onClick={handleJobPreferences}
            nudge={isJobPreferenceComplete}
            tooltipText="Please update your job preferences"
            iconColor={colors.NAVY_BLUE}
          />
          <NudgeIcon
            iconComponent={<ModeOutlined />}
            onClick={handleEditPersonalDetails}
            nudge={shouldShowNudge}
            tooltipText="Please update your personal details"
            iconColor={colors.NAVY_BLUE}
          />


        </div>
      </div>
    </ProfileCard>
  );
}

export default ProfileHeader;
